import { createContext, useContext } from 'react';

interface PageTitleContextValue {
  collapsed: boolean;
}

const PageTitleContext = createContext<PageTitleContextValue>({ collapsed: false });

export const usePageTitleCollapsed = () => useContext(PageTitleContext).collapsed;

export default PageTitleContext;
